import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { LuUserRound } from "react-icons/lu";
import { Button, Field, Input, Select } from "../../components/ui";
import { StatusCard } from "../../components/patterns/StatusCard";
import { useEspecialidades } from "../../hooks/useEspecialidades";
import { t } from "../../i18n";
import { crmError } from "../../lib/validators";
import { useOnboarding } from "./useOnboarding";

export const OnboardingPage: React.FC = () => {
  const location = useLocation();
  const { doctor } = location.state || {};
  const { metadata, ehSecretaria, isSubmitDisabled, handleInputChange, makeRedirect } = useOnboarding(doctor);
  const especialidades = useEspecialidades();
  const [crmTouched, setCrmTouched] = useState(false);

  return (
    <StatusCard
      align="start"
      icon={<LuUserRound size={28} />}
      title={t("onboarding.title")}
      actions={
        <>
          <Button variant="primary" disabled={isSubmitDisabled} onClick={makeRedirect}>
            {t("onboarding.submit")}
          </Button>
          {isSubmitDisabled && (
            <p className="text-center text-caption text-fg-muted">
              {t(ehSecretaria ? "onboarding.hintSecretary" : "onboarding.hintDoctor")}
            </p>
          )}
        </>
      }
    >
      {/* Sem escolha de tipo: este cadastro é sempre de médico. Secretária não se
          cadastra sozinha — é o médico que a vincula em Configurações. */}
      <Field label={t("onboarding.name")}>
        <Input autoComplete="name" value={metadata.nome ?? ""} onChange={(e) => handleInputChange("nome", e.target.value)} />
      </Field>
      {!ehSecretaria && (
        <>
          <Field label={t("onboarding.crm")} error={crmTouched ? crmError(metadata.crm ?? "") : null}>
            <Input
              value={metadata.crm ?? ""}
              placeholder="123456/SP"
              onChange={(e) => handleInputChange("crm", e.target.value)}
              onBlur={() => setCrmTouched(true)}
            />
          </Field>
          <Field label={t("onboarding.specialty")}>
            <Select value={metadata.especialidade ?? ""} onChange={(e) => handleInputChange("especialidade", e.target.value)}>
              <option value="" disabled>{t("onboarding.specialtyPlaceholder")}</option>
              {especialidades.map((e) => (
                <option key={e.chave} value={e.chave}>{e.nome}</option>
              ))}
            </Select>
          </Field>
        </>
      )}
    </StatusCard>
  );
};
